import { Text } from "@chakra-ui/react";

export default function Body2({ children, ...rest }) {
  return (
    <Text fontSize="1.2rem" lineHeight="1.67" letterSpacing="0.2px" {...rest}>
      {children}
    </Text>
  );
}
